export default "__VITE_ASSET__e0c24f09__"